export enum PurchaseRequisitionResult {
    RFQ = 'RFQ',
    QUOTATION = 'QUOTATION',
    ORDER = 'ORDER',
}
